


































































import { Component, Vue } from "vue-property-decorator";
import finances from "@/store/modules/finances";
import { filter } from "vue/types/umd";
import { TransactionType } from "@/models/enums";
import { Transaction } from "@/models";
import auth from '@/store/modules/auth';

@Component({
  components: {
    TransactionsList: () => import("@/components/transaction/TransactionsList.vue"),
    TransactionFilterBar: () => import('@/components/transaction/TransactionFilterBar.vue')
  },
})
export default class TransactionsView extends Vue {
  get transactions(): Transaction[] {
    return finances.transactions
  }
  loading = false
  filter = { 
    year: new Date().getFullYear(),
    month: new Date().getMonth()+1,
    user: auth.userId
  }

  mounted() {
    this.filterTransaction()
  }

  get receitasTotais () {
    var receitas = this.transactions.filter(t => t.type == TransactionType.DEBIT)
    return receitas.reduce((acc, cur) => acc + cur.amount, 0)
  }

  get despesasTotais () {
    var despesas = this.transactions.filter(t => t.type == TransactionType.CREDIT)
    return despesas.reduce((acc, cur) => acc + cur.amount, 0)
  }

  get saldoTotais () {
    var saldo = (this.receitasTotais) - (this.despesasTotais) 
    return saldo
  }

  async filterTransaction() {
    this.loading = true
    await finances.filterTransactions(this.filter)
    this.loading = false
  }

}
